import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../../context/AuthContext";

// Forces a just-signed-up athlete through the consent step before they can
// reach onboarding or the app. No-op once consent is given (or on any normal
// login, where `pendingConsentData` is null).
const ConsentGate = () => {
  const { pendingConsentData } = useAuth();

  if (pendingConsentData) {
    return <Navigate to="/athlete/consent" replace />;
  }

  return <Outlet />;
};

export default ConsentGate;
